__turbopack_context__.v({
  "benefit": "AYjMPW_benefit",
  "description": "AYjMPW_description",
  "mainDescription": "AYjMPW_mainDescription",
  "powerPlugsInfoDescription": "AYjMPW_powerPlugsInfoDescription",
  "rareInfoModal": "AYjMPW_rareInfoModal",
});
